import _classCallCheck from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { isSpanContextValid, TraceFlags, trace } from '@opentelemetry/api';
import { RandomIdGenerator, TRACE_PARENT_HEADER, W3CTraceContextPropagator } from '@opentelemetry/core';
import { FORCE_TRACING_HEADER } from './utils';

var TracingPropagator = /*#__PURE__*/function (_W3CTraceContextPropa) {
  _inherits(TracingPropagator, _W3CTraceContextPropa);

  var _super = _createSuper(TracingPropagator);

  function TracingPropagator() {
    var _this;

    _classCallCheck(this, TracingPropagator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "idGenerator", new RandomIdGenerator());

    return _this;
  }

  _createClass(TracingPropagator, [{
    key: "inject",
    value: function inject(context, carrier, setter) {
      var spanContext = trace.getSpanContext(context);

      if (!spanContext || !isSpanContextValid(spanContext)) {
        return;
      } // Intentionally detach the trace id to prevent Splunk RUM trace references from leaking into Splunk APM


      var newTraceId = this.idGenerator.generateTraceId();
      var traceFlags = Number(spanContext.traceFlags || TraceFlags.NONE).toString(16);
      var traceParent = "00-".concat(newTraceId, "-").concat(spanContext.spanId, "-0").concat(traceFlags);
      setter.set(carrier, TRACE_PARENT_HEADER, traceParent);
      setter.set(carrier, FORCE_TRACING_HEADER, traceFlags);
    }
  }]);

  return TracingPropagator;
}(W3CTraceContextPropagator);

export { TracingPropagator as default };